import React from 'react';
import PropTypes from 'prop-types';
import { GLUtils } from '@capture/gl-core';
import { PatternCropRotatePipeline, PatternUtils ,PatternTypes, PatternGLPipeline } from '@capture/pattern-core';
import GlobalUtil from '../../utils/GlobalUtil'
// import PatternState from 'src/js/components/pattern/PatternState';

export class PatternCropCanvas extends React.Component {
    static propTypes = {
        imageURI: PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);
        this.canvasContainer = React.createRef();
        this.canvasPattern = React.createRef();
        this.overlayCanvas = React.createRef();
        this.gl = null;
        this.frameID = null;
        this.overlayContext = null;
        this.overlayFrameID = null;
        this.texture = null;
        this.textureWidth = 0;
        this.textureHeight = 0;
        this._prevTouchPosition = null;
        this._draw = this._draw.bind(this);
        this._drawOutline = this._drawOutline.bind(this);
        this._onMouseMove = this._onMouseMove.bind(this);
        this._onMouseDown = this._onMouseDown.bind(this);
        this._onMouseUp = this._onMouseUp.bind(this);
        this._handleMouseEvent = this._handleMouseEvent.bind(this);
        this._updateDimension = this._updateDimension.bind(this);
        this._loadTexture = this._loadTexture.bind(this);
        GlobalUtil.trianleToolDraw = this._draw;
        GlobalUtil.trianleToolDrawOutline = this._drawOutline;
        this.atStart = true;
    }

    componentDidMount() {
        this._loadTexture(this.props.imageURI);
        this._updateDimension();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.imageURI !== nextProps.imageURI ) {
            this._loadTexture(nextProps.imageURI);
        }
    }

    _loadTexture(imageURI) {
        window.addEventListener('resize', this._updateDimension);
        this.gl = this.canvasPattern.current.getContext('webgl', { antialias: true });
        GLUtils.loadTexture(this.gl, imageURI, (texture, width, height) => {
            this.texture = texture;
            this.textureWidth = width;
            this.textureHeight = height;
            if (this.atStart) {
                this.atStart = false;
                GlobalUtil.drawID = requestAnimationFrame(GlobalUtil.trianleToolDraw);
                setTimeout(() => {cancelAnimationFrame(GlobalUtil.drawID)},500);
            }
            //GlobalUtil.drawID = requestAnimationFrame(this._draw);
            this._updateDimension();
        });

        this.overlayContext = this.overlayCanvas.current.getContext('2d');
        //this.overlayFrameID = requestAnimationFrame(this._drawOutline);
        const that = this;
        'mousedown touchstart'.split(' ').forEach((eventType) => {
            that.canvasContainer.current.addEventListener(eventType, this._onMouseDown);
        });
    }

    _onMouseDown(event) {
        const that = this;
        'mousemove touchmove'.split(' ').forEach((eventType) => {
            that.canvasContainer.current.addEventListener(eventType, this._onMouseMove);
        });
        'mouseup mouseleave touchend'.split(' ').forEach((eventType) => {
            that.canvasContainer.current.addEventListener(eventType,this._onMouseUp);
        });
        this._handleMouseEvent(event);
    }

    _onMouseMove(event) {
        this._handleMouseEvent(event);
    }

    componentWillUnmount() {
        window.removeEventListener('resize',this._updateDimension);
        const that = this;
        'mousedown touchstart'.split(' ').forEach((eventType) => {
            that.canvasContainer.current.removeEventListener(eventType, this._onMouseMove);
        });
        'mousemove touchmove'.split(' ').forEach((eventType) => {
            that.canvasContainer.current.removeEventListener(eventType, this._onMouseMove);
        });
        'mouseup mouseleave touchend'.split(' ').forEach((eventType) => {
            that.canvasContainer.current.removeEventListener(eventType, this._onMouseUp);
        });
        cancelAnimationFrame(this.frameID);
        cancelAnimationFrame(this.overlayFrameID);
        if (this.gl) {
            this.gl.getExtension('WEBGL_lose_context').loseContext();
            this.gl = null;
        }
    }

    _onMouseUp(event) {
        this._handleMouseEvent(event);
        const that = this;
        'mousemove touchmove'.split(' ').forEach((eventType) => {
            that.canvasContainer.current.removeEventListener(eventType, this._onMouseMove);
        });
        'mouseup mouseleave touchend'.split(' ').forEach((eventType) => {
            that.canvasContainer.current.removeEventListener(eventType, this._onMouseUp);
        });
        this._prevTouchPosition = null;
    }

    _handleMouseEvent(event) {
        const overlay = this.canvasContainer.current;
        if (overlay === null) {
            return;
        }
        const boundingRect = overlay.getBoundingClientRect();
        const overlayOffset = {
            left: boundingRect.left + document.documentElement.scrollLeft,
            top: boundingRect.top //+ document.documentElement.scrollTop
        };
        let touchX = undefined, touchY = undefined;
        if (event.type === "touchstart") {
            document.querySelector("#root").classList.add("preventScrolling");
        }
        if (event.type === "touchend") {
            document.querySelector("#root").classList.remove("preventScrolling");
        }
        if (event.type === 'touchmove' || event.type === 'touchstart' || event.type === 'touchend') {
            const touch = event.changedTouches[0];
            touchX = touch.clientX;
            touchY = touch.clientY;
        } else {
            touchX = event.clientX;
            touchY = event.clientY;
        }
        const touchPositionRelativeToOverlay = {
            x : Math.round(touchX - overlayOffset.left),
            y : Math.round(touchY - overlayOffset.top)
        };
        if (touchPositionRelativeToOverlay.x < 0
            || touchPositionRelativeToOverlay.x > boundingRect.width
            || touchPositionRelativeToOverlay.y < 0
            || touchPositionRelativeToOverlay.y > boundingRect.height) {
            return;
        }
        const touchPosition = {
            x: touchPositionRelativeToOverlay.x / boundingRect.width,
            y: touchPositionRelativeToOverlay.y / boundingRect.height
        };
        if (this._prevTouchPosition !== null) {
           // ingestManager.sendEvent(this.props.ccxIngest, event_type_click, 'crop', 'Patterns', event_workflow_asset_edit);
           // PatternState.offset = [ PatternState.offset[0] + touchPosition.x - this._prevTouchPosition.x,
		   //     PatternState.offset[1] + touchPosition.y - this._prevTouchPosition.y ];
		   var offset = PatternGLPipeline.getOffset();
		   this._setPatternOffset([ offset[0] + touchPosition.x - this._prevTouchPosition.x,
			     offset[1] + touchPosition.y - this._prevTouchPosition.y ]);
        }
		this._prevTouchPosition = touchPosition;
	}
	
	_setPatternOffset(offsetValue) {
		PatternGLPipeline.setOffset(offsetValue);
		PatternCropRotatePipeline.setOffset(offsetValue);
    }

    _updateDimension() {
        const targetLength = 320 - 36;
        this.canvasPattern.current.width = targetLength;
        this.canvasPattern.current.height = targetLength;
        this.overlayCanvas.current.width = targetLength;
        this.overlayCanvas.current.height = targetLength;
    }

    _draw() {
        if (this.canvasPattern.current) {
            PatternCropRotatePipeline.bind(this.gl);
            PatternCropRotatePipeline.setViewSize(this.gl, this.canvasPattern.current.width, this.canvasPattern.current.height);
            PatternCropRotatePipeline.setSize(this.gl, this.textureWidth, this.textureHeight);
            PatternCropRotatePipeline.draw(this.gl, this.texture);
            GlobalUtil.printLog("draw of crop canas");
            GlobalUtil.drawID = requestAnimationFrame(this._draw);
            //GlobalUtil.drawID = this.frameID;
        }
    }

    _drawOutline() {
        const width = this.overlayContext.canvas.width;
        const height = this.overlayContext.canvas.height;
        this.overlayContext.clearRect(0, 0, width, height);
        this.overlayContext.strokeStyle = 'rgba(' + 0.0 + ',' + 149.0 + ',' + 217.0 + ',' + 255.0 + ')';
        this.overlayContext.strokeWidth = 2.0;
        const points = PatternUtils.getPatternOutlinePoints(PatternCropRotatePipeline.getPatternType());
        if (points.length === 3) {
            this.overlayContext.beginPath();
            this.overlayContext.moveTo(points[0][0] * width, (1 - points[0][1]) * height);
            this.overlayContext.lineTo(points[1][0] * width, (1 - points[1][1]) * height);
            this.overlayContext.lineTo(points[2][0] * width, (1 - points[2][1]) * height);
            this.overlayContext.lineTo(points[0][0] * width, (1 - points[0][1]) * height);
            this.overlayContext.stroke();
        }
        this.overlayContext.beginPath();
        this.overlayContext.rect(0, 0, width, height);
        this.overlayContext.stroke();
        GlobalUtil.printLog("drawoutline of crop canvas");
        GlobalUtil.drawOutlineID = requestAnimationFrame(this._drawOutline);
        //GlobalUtil.drawOutlineID = this.overlayFrameID;
    }

    render() {
        return (
            <div className="pattern-overlay" data-test-id="pattern-overlay" ref={this.canvasContainer}
                style={{ display: 'flex', justifyContent: 'center', alignItems : 'center', margin: '18px', position: 'relative' }}>
                <div >
                    <canvas className="pattern-capture-overlay" style={{position: 'absolute'}} ref={this.overlayCanvas} />
                    <canvas data-test-id="pattern-canvas" ref={this.canvasPattern}/>
                </div>
            </div>
        );
    }
}

export default PatternCropCanvas;